import { render } from "./TransactionPage.vue?vue&type=template&id=53859511&ts=true"
import script from "./TransactionPage.vue?vue&type=script&lang=ts"
export * from "./TransactionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__